module.exports = __webpack_public_path__ + "img/horizontal_7_3_8003.9627a774.png";